import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { IoCreate } from "react-icons/io5";
import { Button, Container, Row, Col, Spinner, Card } from "react-bootstrap";

const DetailUser = () => {
  const { user } = useSelector((state) => state.auth);
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.uuid) {
      const fetchData = async () => {
        const token = localStorage.getItem("token");

        if (!token) {
          setErrorMessage("Token tidak ditemukan. Silakan login kembali.");
          setIsLoading(false);
          return;
        }

        try {
          const response = await axios.get(
            `https://c-greenproject.org:8000/users/${user.uuid}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setUserData(response.data);
        } catch (error) {
          console.error("Error fetching data:", error);
          if (error.response?.status === 404) {
            setErrorMessage("User tidak ditemukan.");
          } else if (error.response?.status === 401) {
            setErrorMessage("Unauthorized. Silakan login kembali.");
          } else {
            setErrorMessage("Gagal memuat data user.");
          }
        } finally {
          setIsLoading(false);
        }
      };

      fetchData();
    }
  }, [user?.uuid]);

  return (
    <Container>
      <h2 className="title mt-3 text-center">
        <strong>User Details</strong>
      </h2>

      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "300px" }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      ) : errorMessage ? (
        <p className="text-danger text-center">{errorMessage}</p>
      ) : userData ? (
        <Card className="p-4 shadow-sm mt-3">
          <Row>
            <Col
              xs={12}
              md={4}
              className="mb-3 d-flex flex-column align-items-center"
            >
              {userData.additionalInfo?.url ? (
                <img
                  src={userData.additionalInfo.url}
                  alt={userData.name}
                  className="img-fluid rounded"
                  style={{
                    width: "200px",
                    height: "200px",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <p>Foto tidak tersedia</p>
              )}
              <Button
                onClick={() => navigate(`/profile/edit/${userData.uuid}`)}
                className="btn btn-primary mt-2"
                style={{ width: "200px" }}
              >
                <IoCreate style={{ fontSize: "18px" }} className="me-1" /> Edit
                Profile
              </Button>
            </Col>
            <Col xs={12} md={8}>
              <h5 className="fw-bold">{userData.name || "-"}</h5>
              <Row className="mt-3">
                <Col xs={5} className="text-muted">
                  ID Blockchain
                </Col>
                <Col xs={7} className="text-break">
                  {userData.uuid || "-"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={5} className="text-muted">
                  Email
                </Col>
                <Col xs={7} className="text-break">
                  {userData.email || "-"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={5} className="text-muted">
                  Nomor HP
                </Col>
                <Col xs={7} className="text-break">
                  {userData.additionalInfo?.nohp || "-"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={5} className="text-muted">
                  Alamat
                </Col>
                <Col xs={7} className="text-break">
                  {userData.additionalInfo?.alamat || "-"}
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      ) : (
        <p className="text-center">Data user tidak tersedia.</p>
      )}
    </Container>
  );
};

export default DetailUser;
